import { format, parseISO } from 'date-fns'

/**
 * Formats an enrollment window's `endsAt` (ISO date-time, end-of-day inclusive)
 * as a "MMMM d" label, e.g. `"August 11"`. Formatted in UTC so the calendar
 * day is deterministic regardless of the browser's timezone (a `23:59Z`
 * end-of-day must not roll back to the previous day west of UTC).
 *
 * Returns `undefined` for missing or invalid input so callers can fall back to
 * a preformatted string.
 */
export const formatEnrollmentDate = (iso?: string): string | undefined => {
  if (!iso) return undefined
  try {
    const parsed = parseISO(iso)
    if (Number.isNaN(parsed.getTime())) return undefined
    // Shift the instant so the Date's local components equal its UTC
    // components; `format` then renders the UTC calendar day.
    const utc = new Date(parsed.getTime() + parsed.getTimezoneOffset() * 60000)
    return format(utc, 'MMMM d')
  } catch {
    return undefined
  }
}
